import React, { createRef, useEffect, useState } from 'react'
import { FC } from 'react'
import { Tooltip } from "react-tippy";
import { useDispatch, useSelector } from 'react-redux';
import { Element } from "../../../models/elementModel";
import produce from 'immer';
import { startEditElement } from '../../../actions/elementListAction';
import DecoupledEditor from '@ckeditor/ckeditor5-build-decoupled-document';
import { CKEditor } from '@ckeditor/ckeditor5-react';
import DOMPurify from "dompurify";
import { getSession } from '../../../selectors/appSelectors';
import './Remarks.scss';

export interface TypographyElementProps {
    index: string;
    element: Element;
    isPreview?: boolean;
}

const TypographyElement: FC<TypographyElementProps> = ({
    index,
    element,
    isPreview = false,
}) => {
    const dispatch = useDispatch();
    const sessionState = useSelector(getSession);
    const [viewRemark, setViewRemark] = useState(sessionState.viewRemark);
    const [open, setIsOpen] = useState(false);

    useEffect(() => {
        setViewRemark(sessionState.viewRemark)
        console.log(sessionState.viewRemark)

    }, [sessionState])

    const toolBarRef = createRef<HTMLDivElement>();
    const editorConfiguration = {
        toolbar: {
            items: [
                'heading', '|',
                'alignment', '|',
                'bold', 'italic', 'strikethrough', 'underline', 'subscript', 'superscript', '|',
                'bulletedList', 'numberedList', 'todoList', '|',
                'fontfamily', 'fontsize', 'fontColor', 'fontBackgroundColor', '|',
                'code', 'codeBlock', '|',
                'outdent', 'indent', '|',
                'undo', 'redo'
            ],
            shouldNotGroupWhenFull: true
        },
        fontSize: {
            options: [
                9,
                11,
                13,
                15,
                17,
                19,
                21
            ],
            supportAllValues: true
        },
    };

    const defaultStyles = {
        marginTop: element.properties.isMarginAll
            ? element.styles.margin + "px"
            : element.styles.marginTop + "px",
        marginRight: element.properties.isMarginAll
            ? element.styles.margin + "px"
            : element.styles.marginRight + "px",
        marginBottom: element.properties.isMarginAll
            ? element.styles.margin + "px"
            : element.styles.marginBottom + "px",
        marginLeft: element.properties.isMarginAll
            ? element.styles.margin + "px"
            : element.styles.marginLeft + "px",
        textAlign: element.styles.textAlign,
        height: (element.styles.height === "0" || element.styles.height === undefined || element.styles.height === "") ? "" : element.styles.height + "px",
        width: (element.styles.width === "0" || element.styles.width === undefined || element.styles.width === "") ? "" : element.styles.width + "px"
    };

    //custome css - start
    const styleList = element.properties.cssStyles;

    const styleObj: { [key: string]: any } = {};

    for (let index = 0; index < styleList.length; index++) {
        styleObj[styleList[index].retrivedStyle] = styleList[index].value;
    }
    //custome css - end

    const mySafeHTML = DOMPurify.sanitize(element.properties.text);
    return (
      <div
        key={index}
        style={{ ...defaultStyles }}
        className={`${
          element.properties.display === false ? "blur-element" : ""
        }`}
      >
        <Tooltip title={element.properties.tooltip}>
          {!isPreview && (
            <>
              <div ref={toolBarRef}></div>
              <CKEditor
                editor={DecoupledEditor}
                config={editorConfiguration}
                data={element.properties.text}
                onReady={(editor: {
                  ui: { view: { toolbar: { element: any } } };
                }) => {
                  if (toolBarRef.current) {
                    toolBarRef.current.appendChild(
                      editor.ui.view.toolbar.element
                    );
                  }
                }}
                onBlur={(event: any, editor: { getData: () => any }) => {
                  const data = editor.getData();
                  const newElement = produce(element, (draft) => {
                    draft.properties.text = data;
                  });
                  dispatch(startEditElement(newElement));
                }}
              />
            </>
          )}
          {isPreview && (
            <div
              style={{ ...defaultStyles }}
              dangerouslySetInnerHTML={{ __html: mySafeHTML }}
            />
          )}
        </Tooltip>
        {isPreview &&
          viewRemark &&
          (element.properties.remark1 ||
            element.properties.remark2 ||
            element.properties.remark3 ||
            element.properties.remark4) && (
            <Tooltip
              interactive
              open={open}
              onRequestClose={() => setIsOpen(false)}
              html={
                <>
                  <h6>Remarks of {element.name}</h6>
                  {element.properties.remark1 !== undefined &&
                    element.properties.remark1 !== "" && (
                      <div className="remark">
                        Remark 1 : {element.properties.remark1}
                      </div>
                    )}
                  {element.properties.remark2 !== undefined &&
                    element.properties.remark2 !== "" && (
                      <div className="remark">
                        Remark 2 : {element.properties.remark2}
                      </div>
                    )}
                  {element.properties.remark3 !== undefined &&
                    element.properties.remark3 !== "" && (
                      <div className="remark">
                        Remark 3 : {element.properties.remark3}
                      </div>
                    )}
                  {element.properties.remark4 !== undefined &&
                    element.properties.remark4 !== "" && (
                      <div className="remark">
                        Remark 4 : {element.properties.remark4}
                      </div>
                    )}
                  {(element.properties.remark1 === undefined ||
                    element.properties.remark1 === "") &&
                    (element.properties.remark2 === undefined ||
                      element.properties.remark2 === "") &&
                    (element.properties.remark3 === undefined ||
                      element.properties.remark3 === "") &&
                    (element.properties.remark4 === undefined ||
                      element.properties.remark4 === "") && (
                      <div>No Remarks to Display</div>
                    )}
                </>
              }
              position="left"
            >
              <div style={{ textAlign: "end" }}>
                <i
                  className="fa fa-info-circle"
                  aria-hidden="true"
                  onClick={() => {
                    setIsOpen(true);
                  }}
                ></i>
              </div>
            </Tooltip>
          )}
      </div>
    );
}

export default TypographyElement
